export default {
  collapse: 'メニューを折りたたむ',
  expand: 'メニューを展開',
};
